<template>
    <div class="channel-menu">
        <div v-for="groupId in Object.keys(menuGroups)" :key="groupId" class="group-wrapper">
            <div
                class="group"
                :class="{
                    collapsed: isGroupCollapsed(groupId),
                    selected: isGroupSelected(groupId),
                }"
                @click="toggleGroup(groupId)"
            >
                <div class="left">
                    <span class="icon">
                        <HomeIcon v-if="groupId === 'Setting'" />
                        <HomeIcon v-if="groupId === 'Templates'" />
                    </span>
                    <span class="title">{{ $t(`whatsapp_business_api.${groupId}`) }}</span>
                </div>
                <div class="right">
                    <IconButton :on-click="() => toggleGroup(groupId)" class="collapse-button">
                        <a-icon type="caret-down" v-if="!isGroupCollapsed(groupId)" @click="toggleGroup(groupId)" />
                        <a-icon type="caret-up" v-else @click="toggleGroup(groupId)" />
                    </IconButton>
                </div>
            </div>
            <div class="list" :class="{ hidden: !isGroupCollapsed(groupId) }">
                <div :key="item.id" v-for="item in menuGroups[groupId].filter((x) => !x.disabled)">
                    <div class="item" :class="{ selected: value === item.id }" @click="$emit('input', item.id)">
                        {{ $t(`whatsapp_business_api.${item.id}`) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import log2 from "../../../utils/log2";
import IconButton from "../Settings/components/IconButton.vue";
import HomeIcon from "../../../components/svg/icons/HomeIcon.vue";
import WhatsappChannelMenuTypes from "./WhatsappChannelMenuTypes";

const log = log2("ChannelMenu");
export default {
    name: "ChannelMenu",
    components: {
        IconButton,
        HomeIcon,
    },
    props: {
        value: {
            type: String,
            default: "detail",
        },
    },
    computed: {},
    data() {
        return {
            unCollapsedGroupIds: [],
            menuGroups: _.groupBy(WhatsappChannelMenuTypes, "group"),
        };
    },
    methods: {
        isGroupCollapsed(groupId) {
            return !this.unCollapsedGroupIds.includes(groupId);
        },
        isGroupSelected(groupId) {
            return this.menuGroups[groupId].some((item) => item.id === this.value);
        },
        toggleGroup(groupId) {
            if (this.isGroupCollapsed(groupId)) {
                this.unCollapsedGroupIds.push(groupId);
            } else {
                this.unCollapsedGroupIds = this.unCollapsedGroupIds.filter((id) => id !== groupId);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.dark-mode {
    .channel-menu {
        background: #1e1e2d !important;
        border-radius: 0px 0 0 !important;
    }

    .item {
        color: #fff !important;
    }
}

.channel-menu {
    width: 268px;
    min-width: 268px;
    height: calc(100%);
    min-height: calc(100%);
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-right: 1px solid var(--color-border-default);
    overflow-y: auto;
    background: var(--color-bg-default);
    border-radius: 16px 0 0;
    padding: 5px;
    padding-top: 8px;
    //border:1px solid red;
    .group-wrapper {
    }

    .group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-transform: uppercase;
        user-select: none;
        cursor: pointer;
        padding: 5px;

        &:hover {
            background: var(--color-bg-neutral-low-hover);
        }

        .left {
            display: flex;
            gap: 5px;
        }

        &.selected {
            span.icon {
                .MuiSvgIcon-root {
                    color: var(--color-bg-primary-default);
                }
            }
        }

        .title {
            text-transform: uppercase;
            font-weight: 700;
        }

        span.icon {
            .MuiSvgIcon-root {
                color: var(--color-icon-default);
                font-size: 20px;
            }
        }
    }

    .list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        transition: all 0.2s ease-in-out;
        box-sizing: border-box;
        overflow: hidden;
        max-height: 500px;

        &.hidden {
            max-height: 0;
        }

        .item {
            display: flex;
            align-items: center;

            width: 100%;
            min-height: 36px;
            color: var(--color-text-strong-default);
            font-weight: 500;
            padding: 5px;
            padding-left: 8px;
            margin: 0 8px;
            border-radius: 8px;
            cursor: pointer;
            text-decoration: none;
            transition: transform 0.12s ease, background-color 0.14s ease;
            gap: 5px;

            .MuiSvgIcon-root {
                color: var(--color-icon-default);
            }

            &:hover {
                background: var(--color-bg-neutral-hover);
                color: var(--color-text-strong-default);
            }

            .count {
                display: inline-block;
                font-size: 11px;
                font-weight: 700;
                line-height: 16px;
                padding: 0 4px;
                border-radius: 4px;
                letter-spacing: -0.24px;
                min-height: 16px;
                text-transform: uppercase;
                width: fit-content;
                align-items: center;
                text-decoration: none;
                height: fit-content;
                background: var(--color-bg-default);
                color: var(--color-text-default);
                border: 1px solid var(--color-border-default);
                min-width: fit-content;
            }

            .metas {
                display: flex;
                flex-direction: column;
                gap: 3px;

                .subtitle {
                    font-size: 12px;
                    font-weight: 400;
                }

                .title,
                .subtitle {
                    line-height: 15px;
                }
            }

            &.selected {
                background: var(--color-bg-active);
                overflow: hidden;
                border-left: 4px solid var(--color-bg-primary-default);

                .MuiSvgIcon-root {
                    color: var(--color-bg-primary-default);
                }
            }

            &.disabled {
                background: #f8f8f8;
                cursor: not-allowed;
            }

            &.danger {
                .MuiSvgIcon-root {
                    color: var(--color-icon-critical-default);
                }
            }

            &.hidden {
                display: none;
            }
        }
    }
}
</style>
